export const CART_RETURN_KEY = "njtCartReturnTo"

const HUB_LABELS = {
  sourcing: "Part Lookup",
  contact: "Contact",
  about: "About",
  repairs: "Repair Services",
  "new-inventory": "New Inventory",
  quote: "Request a Quote",
}

const looksLikeShopifyId = (segment = "") =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment) ||
  /^gid:/i.test(segment)

const looksLikeUuidLabel = (label = "") =>
  /^[0-9a-f]{8}[\s-][0-9a-f]{4}/i.test(label.trim())

const formatSlugLabel = (slug = "") => {
  // Part numbers read better uppercase than title-cased ("2711P-T10C22D9P")
  if (/[0-9]/.test(slug) && /[a-z]/i.test(slug) && slug.length <= 40) {
    return slug.toUpperCase()
  }
  return slug
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

export const getPageLabelFromPath = (pathname) => {
  if (!pathname || pathname === "/" || pathname === "") return "Home"

  const segments = pathname.replace(/\/$/, "").split("/").filter(Boolean)
  const last = segments[segments.length - 1] || ""

  if (HUB_LABELS[last]) return HUB_LABELS[last]
  if (segments[0] === "listing" || segments[0] === "parts") return "Product"

  // Shopify product pages: /{mpn}/{shopifyNodeId}/
  if (segments.length >= 2 && looksLikeShopifyId(last)) {
    return formatSlugLabel(segments[segments.length - 2])
  }

  if (looksLikeShopifyId(last)) return "Product"

  return formatSlugLabel(last)
}

export const normalizeReturnLink = (link) => {
  if (!link?.path || link.path.startsWith("/cart")) return null

  const labelFromPath = getPageLabelFromPath(link.path)
  if (!link.label || looksLikeUuidLabel(link.label)) {
    return { path: link.path, label: labelFromPath }
  }

  return link
}

export const saveCartReturnPath = (path, label) => {
  if (typeof window === "undefined" || !path || path.startsWith("/cart")) return
  try {
    sessionStorage.setItem(
      CART_RETURN_KEY,
      JSON.stringify({ path, label: label || getPageLabelFromPath(path) })
    )
  } catch (_) {
    /* ignore storage errors */
  }
}

export const readCartReturnPath = () => {
  if (typeof window === "undefined") return null
  try {
    const stored = sessionStorage.getItem(CART_RETURN_KEY)
    if (!stored) return null
    return normalizeReturnLink(JSON.parse(stored))
  } catch (_) {
    /* ignore storage errors */
  }
  return null
}

export const readReferrerReturnPath = () => {
  if (typeof window === "undefined" || !document.referrer) return null
  try {
    const ref = new URL(document.referrer)
    if (ref.origin !== window.location.origin) return null
    if (ref.pathname.startsWith("/cart")) return null
    return normalizeReturnLink({
      path: ref.pathname + ref.search,
      label: getPageLabelFromPath(ref.pathname),
    })
  } catch (_) {
    return null
  }
}

export const truncateLabel = (text, max = 48) => {
  if (!text) return ""
  if (text.length <= max) return text
  return `${text.slice(0, max - 1).trim()}…`
}

export const getProductReturnLink = (lineItems, getProductUrl) => {
  if (!lineItems?.length) return null
  const item = lineItems[0]
  const path = getProductUrl(item.variant.id)
  if (!path || path === "#") return null
  return { path, label: truncateLabel(item.title) }
}

export const resolveCartReturnLink = (lineItems, getProductUrl) => {
  const productLink = getProductReturnLink(lineItems, getProductUrl)
  const stored = readCartReturnPath() || readReferrerReturnPath()

  if (stored && productLink && stored.path === productLink.path) {
    return { path: stored.path, label: productLink.label }
  }
  if (stored) return stored
  if (productLink) return productLink
  return { path: "/", label: "Continue Shopping" }
}